<script setup lang="ts">
import { type SearchCommentsPayload } from '@store'

useScrollRestoration()

const route = useRoute()
const isLoading = ref(false)
const isError = ref(false)
const searchStore = useSearchStore()

// 최초 랜딩시 댓글 조회
onMounted(async () => {
  const { isChanged, newPayload } = checkEqualCommentsPayload()
  if (searchStore.comments.items.length && !isChanged) return
  await handleOnFetchComments(true, newPayload)
})

// 검색 키워드에 따라 댓글 목록 조회
watch(
  () => searchStore.keyword,
  () => {
    handleOnFetchComments(true)
  }
)

// 댓글 목록 조회 쿼리 비교
const checkEqualCommentsPayload = () => {
  const newPayload = {
    query: route.query.keyword ? String(route.query.keyword) : '',
  }
  const isChanged = newPayload.query !== searchStore.comments.payload.query
  return { isChanged, newPayload }
}

// 댓글 목록 조회
const handleOnFetchComments = async (
  refresh = false,
  payload?: Partial<SearchCommentsPayload>
) => {
  try {
    isLoading.value = true
    isError.value = false
    await searchStore.fetchSearchComments(
      {
        ...searchStore.comments.payload,
        query: searchStore.keyword,
        ...payload,
      },
      refresh
    )
  } catch {
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="search-result-comment">
    <NovaRecyclerGrid
      v-if="searchStore.comments.items.length"
      :items="searchStore.comments.items"
      :is-last="searchStore.comments.last"
      :is-loading="isLoading"
      :is-error="isError"
      :is-refresh="searchStore.comments.refresh"
      :key-name="'cmtyNttSn'"
      :page-mode="true"
      :error-message="$t('statusMessages.network.error')"
      :responsive="{
        mobile: {
          columns: 1,
          rowGap: 12,
          columnGap: 12,
          padding: { top: 0, right: 10, bottom: 20, left: 10 },
        },
        tablet: { columns: 1, rowGap: 12, columnGap: 12 },
        desktop: {
          columns: 1,
          rowGap: 12,
          columnGap: 12,
        },
      }"
      :buffer="600"
      @load-more="handleOnFetchComments"
    >
      <template #item="{ item }">
        <NovaSearchResultItemComment :source="item" />
      </template>
    </NovaRecyclerGrid>

    <NovaBoxEmptyMessage
      v-if="!searchStore.comments.items.length && !isLoading"
      :message="
        $t('statusMessages.search.empty', { keyword: searchStore.keyword })
      "
      :fill="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.search-result-comment {
  flex-grow: 1;
  height: 100%;

  @include mobile {
    .recycler-view {
      :deep(.scroller) {
        padding: 0 10px 20px;
      }
    }
  }
}
</style>
